module.exports = __webpack_public_path__ + "img/faceErr.1de4392c.png";